import Image from '@src/quince-site-common/src/domains/Image'
import Product from '@src/quince-site-common/src/domains/Product'
import ProductImage from '@src/quince-site-common/src/domains/ProductImage'
import ProductMedia from '@src/quince-site-common/src/domains/ProductMedia'
import { ProductOptionName } from '@src/quince-site-common/src/domains/ProductOption'
import { ProductVariantOption } from '@src/quince-site-common/src/domains/ProductVariant'
import productHelper, { getColorFromSelectedOptions } from '@src/quince-site-common/src/helpers/productHelper'

export const VIDEO_FORCE_POSITON = 2

export const getColorProductMediaCombinations = (product: Product) => {
  const colorOption = product.productOptions.find(po => po.name === ProductOptionName.Color)
  if (!colorOption?.values) {
    return {}
  }
  const colorValueProductImagesMap: Record<string, ProductMedia[]> = {}

  for (const color of colorOption.values) {
    const colorOptions = [
      new ProductVariantOption({
        name: ProductOptionName.Color,
        value: color.value,
      }),
    ]

    const productImages = productHelper.getImagesForOptions(product, colorOptions)

    const productVideo = productHelper.getVideoForOptions(product, colorOptions)[0]

    const productMedia: ProductMedia[] = [...productImages]

    if (productVideo) {
      const forcedVideoIndex = Math.min(VIDEO_FORCE_POSITON - 1, productMedia.length)

      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      const videoIndex = forcedVideoIndex ?? productVideo.videoIndex ?? productImages.length

      productMedia.splice(videoIndex, 0, productVideo)
    }

    colorValueProductImagesMap[color.value] = updatePrimaryMediaForSEOCompliance(
      productMedia,
      color.value,
      product.title,
    )
  }
  return colorValueProductImagesMap
}

const getMediaWithSEOAltText = (mediaItem: ProductMedia, productColor: string, productTitle: string) => {
  return new ProductImage({
    ...mediaItem,
    image: new Image({
      ...(mediaItem as ProductImage).image,
      alt: `${productColor} ${productTitle}`,
    }),
  })
}

export const updatePrimaryMediaForSEOCompliance = (
  productMedia: ProductMedia[],
  productColor: string,
  productTitle: string,
) => {
  const mediaToBeUpdated = productMedia[0]
  if (mediaToBeUpdated && 'image' in mediaToBeUpdated && productColor && productTitle) {
    const updatedMediaItem = getMediaWithSEOAltText(mediaToBeUpdated, productColor, productTitle)
    return [updatedMediaItem, ...productMedia.slice(1)].filter(Boolean)
  }
  return productMedia
}

export const getProductMedia = (product: Product, selectedOptions: ProductVariantOption[]) => {
  const { title } = product
  const color = getColorFromSelectedOptions(selectedOptions)
  const productMedia = productHelper.getProductMedia(product, selectedOptions, {
    forcedVideoPosition: VIDEO_FORCE_POSITON,
  })
  return updatePrimaryMediaForSEOCompliance(productMedia, color, title)
}
